export const initialValuesEditPartner = {
			/*Partner information*/
		title: "",
		active: "",
}